import React from 'react'
import Grid from '@material-ui/core/Grid'
import { Field } from 'react-final-form'
import moment from 'moment'
import {
  List,
  Filter,
  TextField,
  useListRepository,
  useFilter,
  DatePicker
} from 'elentari'
import { useAbility } from '../Usuarios'
import { getListActions } from '../../lib/crudAuthorization'
import bloqueioManualRepository from './bloqueioManualRepository'
import { BloqueioBadgeStatus } from './bloqueioManualActions'
import { formatCpfCnpj } from '../../utils/Formatter'

const BloqueioManualFilter = () => {
  const filter = useFilter({})

  return (
    <Filter
      {...filter}
      labels={{
        simpleFilter: 'Busca simples',
        find: 'Buscar',
        clear: 'Limpar'
      }}
    >
      <Grid spacing={3} container>
        <Grid item xs={12} sm={4}>
          <Field
            fullWidth
            name="cpfcnpj"
            label="CPF/CNPJ"
            component={TextField}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Field fullWidth name="placa" label="Placa" component={TextField} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Field
            fullWidth
            component={DatePicker}
            label="Data Criação De"
            name="createdAt"
          />
        </Grid>
      </Grid>
    </Filter>
  )
}

const BloqueioManual = props => {
  const [ability] = useAbility()

  const listHook = useListRepository({
    repository: bloqueioManualRepository,
    defaultSort: 'createdAt desc',
    path: 'bloqueio-manual-kmm'
  })
  const listOptions = {
    defaultOrder: 'createdAt desc',
    fields: {
      id: {
        label: 'ID'
      },
      createdAt: {
        label: 'Data Criação',
        format: data => moment(data).format('DD/MM/YYYY HH:mm')
      },
      cpfcnpj: {
        label: 'CPF/CNPJ',
        format: data => formatCpfCnpj(data) || '-'
      },
      placa: {
        label: 'Placa',
        format: data => data || '-'
      },
      dataDesbloqueio: {
        label: 'Status',
        format: data =>
          data ? (
            <BloqueioBadgeStatus status="DESBLOQUEIO" label="DESBLOQUEADO" />
          ) : (
            <BloqueioBadgeStatus status="BLOQUEIO" label="BLOQUEADO" />
          )
      }
    }
  }

  const actions = getListActions(ability, listHook, 'bloqueio-manual-kmm')

  return (
    <>
      <BloqueioManualFilter />
      <List
        {...props}
        {...listHook}
        {...actions}
        stickyHeader
        adjustToScreenHeight
        onClickView={null}
        onClickEdit={null}
        onClickRow={item =>
          props.history.push(`/bloqueio-manual-kmm/${item.id}`)
        }
        removeItem={null}
        hideDownloadIcon
        listOptions={listOptions}
      />
    </>
  )
}

export default BloqueioManual
